import React from "react";
import { Input } from "antd";

const { TextArea } = Input;

export default function AddInput(props) {
  if (props.type === "text") {
    return <div className="grid grid-cols-8">
      <div className="py-2 whitespace-nowrap col-span-2">{props.label}</div>
      <div className="col-span-6">
        <Input
          className="rounded-lg py-1 border-gray-200"
          placeholder={props.placeholder}
          allowClear
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          disabled={props.disabled}
        />
      </div>
    </div>;
  }

  if (props.type === "textarea") {
    return (
      <div className="grid grid-cols-8">
        <div className="py-2 whitespace-nowrap col-span-2">{props.label}</div>
        <div className="col-span-6">
          <TextArea 
          rows={4} 
          className="rounded-lg border-gray-200" 
          placeholder={props.placeholder} allowClear 
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          />
        </div>
      </div>
    );
  }
  return false;
}
